import React from 'react';
import {Helmet} from 'react-helmet';
import { store } from '../../../store';

import Tasknav from '../Tasknav'

import Save from '../Save'

import AboutSection from '../Sections/About/AboutSection'

import Profile from '../Sections/Profile/Profile'

import CustomizationPanel from '../Sections/Customization/CustomizationPanel'

import Controller from '../Sections/Customization/Controller'

import LinksFunction from '../Sections/SocialLinks/LinksFunction'
import LinksSection from '../Sections/SocialLinks/LinksSection'

import ImageUploadFunction from '../Sections/Images/ImageUploadFunction'
import {ProPic, CoverImageURL} from '../Sections/Images/ImageSection'

import Menu from '../../Navigation/Menu'

const Fifth = ({onUser, onEdit, onOpen, onRouteChange, onWebsitename, onWebsiteBio, onCustomization, onSelectToolbar, onHighlight, onMenu, highlight, menu, handleOffClick, onClickInside, onClickOutside, onController, controller, profile_name, profile_bio, about, icons, background,onOuterDiv,onInnerDiv, outerdiv, onAboutSwitch, themeAbout}) => {

  return ( 
<div id="scroll" className="editSection">          
<Helmet>
<meta name="viewport" content="width=device-width,initial-scale=1" />
<link href="https://fonts.googleapis.com/css?family=Coiny:400,700,700i|Dancing+Script:400,700,700i|Indie+Flower:400,700,700i|Lato:400,700,700i|Lobster+Two|Merriweather:400,700,700i|Open+Sans:400,700,700i|Pacifico:400,700,700i|Righteous:400,700,700i|Shadows+Into+Light+Two|Lora:400,700|Vibur:400,700,700i|Oswald:400,700|Roboto+Mono:400,700|Roboto:400,700,900|Abel" rel="stylesheet" />
<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css" />
<style type="text/css">{`
@keyframes fadeIn {
  0% {
    opacity: 0;
    visibility: hidden;
  }
  100% {
    opacity: 1;
    visibility: visible;
  }
}
@keyframes fadeOut {
  0% {
    opacity: 1;
  }
  100% {
  	opacity:0;
  	visibility: hidden;
  }
}
h1 {
	font-size:50px;
}
.wrap {
	display:flex;
	flex:2;
	width: ${store.getState().activities.edit ? "99.5vw" : "100vw"};
	height: 100vh;
	flex-direction: column;
	overflow-y: auto;
	background: ${background.color};
}
.bg_out {
	position:fixed;
	z-index: 2;
	max-width:100%;
	max-height:100%;
	top:0;
	left:0;
	right: 0;
	bottom: 0;
}
.bg_img {
	position:fixed;
	z-index: 2;
	max-width:100%;
	max-height:100%;
	object-fit: cover;
	opacity: ${background.opacity};
	top:0;
	left:0;
	right: 0;
	bottom: 0;
}
.bg_img_inside {
	max-width: 100%;
	min-height: 100vh;
	object-fit: cover;
}

.main {
	position: absolute;
	top:0;
	overflow-y: auto;
	height: 100vh;
	width: 100vw;
	background: ${background.color};
	z-index: 0;
}
.dp {
	width: 100%;
	height: 100%;
	transition: .4s ease-in-out;
	object-fit: cover;
	border-radius: 250px;
	z-index: 1;
}
.head {
	animation: fadeIn .5s ease-in-out 0s forwards;
	max-width: 100%;
	background: ${background.color};
	display: flex;
	justify-content: center;
	height: 100%;
	margin:0;
	flex:2;
	z-index: 2;
}
.profile-card {
	animation: 1s ease-in-out 0s 1 fadeIn;
	display: flex;
	flex-direction:column;
	align-items: center;
	justify-content: center;
	height: 90vh;
	padding: 5em;
	z-index: 2;
}

.profile {
	margin:1em 0;
	text-align: left;
	width:100%;
	display: flex;
	justify-content: center;
	align-items: center;
	flex:2;
}
.profile_pic {
	width: 250px;
	max-width: 250px;
	height: 250px;
	max-hight: 250px;
	border-radius: 250px;
	margin-right:2em;
	box-shadow: 0 0 20px ${icons.color === "#000" ? '#fff' : '#000'};
	flex:1;
}
.profile_name {
	font-family: ${profile_name.font};
	text-transform: capitalize;
	font-size:${profile_name.size}px;
	color:${profile_name.color};
	display: block;
	line-height:1.2em;
	min-width: 50%;
}
.profile_desc {
	line-height:1em;
	font-family:${profile_bio.font};
	color:${profile_bio.color};
	font-size:${profile_bio.size}px;
	min-width: 50%;
}
.foot {
	position: fixed;
	display: flex;
	flex:2;
	bottom:0;
	z-index: 9;
	width: 95vw !important;
	padding-bottom:20px;
}
.to_about {
	color:${icons.color};
	width:100px;
	text-align: left;
	font-size:16px;
}
.to_about span {
	width:150px;
	font-weight: 900;
	transition: .15s ease-in-out;
	cursor: pointer;
}
.to_about span:hover {
	word-spacing: 10px;
}
.arrow_bottom {
	font-size: 18px;
}
.social_media {
	width: 100%;
	text-align: left;
}
.socialicon {
	font-size:22px;
	color:${icons.color};
	background: transparent;
	border-radius: 10px;
	text-align: center;
	margin:0.2em .8em 0em 0em;
	text-decoration: none;
}
.about {
	font-family: ${about.font};
	font-size:${about.size}px;
	color:${about.color};
	width: 55%;
	margin:5em auto 2em auto;
	text-align: justify;
	text-justify: inter-word;
}
.paragraph,
p {
	font-family: ${about.font};
	color:${about.color};
	margin-bottom:1em;
	font-size:${about.size}px;
	line-height:1.8;
}
p a {
	text-decoration:underline;
	color:${about.color};
}
p a:hover {
	text-decoration:underline;
	color:${about.color};
}
.profile_pic_sml {
	width:50px;
	height: 50px;
	border-radius: 50px;
	position: fixed;
	z-index: 10;
	top:1em;
	cursor: pointer;
	right:15vw;
	padding:3px;
	transition: .15s ease-in-out;
}
.profile_pic_sml:hover {
	box-shadow: 0 0 1px 2px ${icons.color};
}
.profile_pic_sml:active {
	box-shadow: 0 0 6px 2px ${icons.color};
}
.dp_sml {
	width: 100%;
	height: 100%;
	object-fit: cover;
	border-radius: 50px;
}
@media only screen and (max-width : 992px) {
body {
	overflow: visible;
}
.profile-card {
	padding:5em 2em;
}
.wrap {
	display:block;
}
.profile {
	display:flex;
	flex-direction: column;
}
.profile_pic {
	margin:0;
	max-width: 250px;
	max-height: 250px;
}
.about {
	width: 70%;
}
.profile_pic_sml {
	top:0;
	right:0px;
}
}
.disinp {
	width:300px;
}
.img_edit_cover {
	position:absolute;
	left:1em;
}
.nothing {
	animation: fadeOut .25s ease-in-out 0s forwards;
	overflow-y:hidden;
}
.editv {
	top:5em;
}
.abt {
	padding:1em;
}
`}</style>
</Helmet>
{(store.getState().activities.edit)         
? <div className="toptoolbar">
	<Tasknav
	onRouteChange={onRouteChange}
	onEdit={onEdit}
	onOpen={onOpen}
	onHighlight={onHighlight}
	highlight={highlight}
	onClickInside={onClickInside}
    onClickOutside={onClickOutside}
	/><span className="navmargin"><br /><br /><br /></span></div>
: null
}
<div className='wrap'>
<div className={ !themeAbout ? "head" : "head nothing" }>
{(store.getState().activities.edit)  
? <span onClick={
  (open,select)=>
  {
  if(store.getState().activities.edit && outerdiv) {
  onOpen('cover')
  }
  }}  className="img_edit_cover"><i className="fa fa-camera img_edit_cover_icon" aria-hidden="true"></i> Upload</span>
: null
}
<div className="bg_img">
{CoverImageURL() === null
  ? null
  : <img className="bg_img_inside" src={CoverImageURL()} alt="Background" />
}
</div>
<div className="profile-card"
onMouseOver = {onInnerDiv.bind()}
onMouseOut = {onOuterDiv.bind()}>
<div className="profile">
{(store.getState().activities.edit)  
? <div className="profile_pic select" onClick={(open)=>
  {
  onOpen('propic')
  }}><i class="fa fa-camera img_edit_top_dp" aria-hidden="true"></i><img alt="dp" src={ProPic()} className="dp"/></div>
: ProPic() !== null
  ? <div className="profile_pic"><img alt="dp" src={ProPic()} className="dp"/></div>
  : null
}
<div className={
	store.getState().activities.edit
	? 'select_col'
	: ''
}>
<Profile onWebsitename={onWebsitename} onWebsiteBio={onWebsiteBio} onHighlight={onHighlight} highlight={highlight} />
</div>
</div>
<div className="foot">
<div className="social_media">
<LinksFunction 
  onClickInside={onClickInside}
  onClickOutside={onClickOutside}
  alignCenter={'true'}/>        
<LinksSection onOpen={onOpen}/>
{(store.getState().activities.edit) 
? <span className="fa fa-plus addnew socialicon" onClick={(open)=>{onOpen('links')}}></span>
: null
}
</div>
<div class="to_about">
	<span id="to_about" onClick={onAboutSwitch}>About <span class="arrow_bottom">&#x21b4;</span></span>
</div>
</div>
</div>
</div>
<div className={ themeAbout ? "main" : "main nothing" }>
<div className={store.getState().activities.edit
	? 'profile_pic_sml editv'
	: 'profile_pic_sml'
} id="to_home" onClick={onAboutSwitch}>
    <img src={ProPic()} class="dp_sml"/>
</div>
<div className={
  store.getState().activities.edit
  ? 'about abt select_col'
  : 'about'
}>
<AboutSection/>
</div>
</div>
</div>
{highlight === 'save'     
? <Save onHighlight={onHighlight} />
: null
}
{(!store.getState().activities.edit)         
?<span className="editbtn" onClick={(edit,open)=>{
onEdit(true)
onOpen(null)
onHighlight(null)
}}>Edit</span>
:<span />
}
{store.getState().activities.open === 'menu'
? <Menu
	onOpen={onOpen}
	onRouteChange={onRouteChange} 
	onClickInside={onClickInside}
	onClickOutside={onClickOutside}/>
: null
}
<Controller
	onOpen={onOpen}
	onSelectToolbar={onSelectToolbar}
/>
<CustomizationPanel 
	onEdit={onEdit}
	onOpen={onOpen}
	onSelectToolbar={onSelectToolbar}
	onCustomization={onCustomization}
	onClickInside={onClickInside}
    onClickOutside={onClickOutside} />
<ImageUploadFunction 
	onClickInside={onClickInside}
	onClickOutside={onClickOutside}/>
</div>
  )
}
export default Fifth